<template>
  <div class="pg-404">
    <div class="pg__bd">
      <h1>404</h1>
      <p><strong>The page you are trying to visit doesn't exist.</strong> Check the web address and try again or return to the <router-link :to="{name: 'Home'}">home page</router-link>.</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Home',
  components: {}
};
</script>
<style lang="scss" scoped>
  .pg-404 {
    clear:both;
    color:#fff;
    height:100vh;
    display:flex;
    padding:52px;
    padding-top:20vh;
    box-sizing:border-box;
    justify-content:center;
  }
  p {font-size:24px;line-height:1.5;}
  h1 {margin-bottom:32px;font-size:72px;}
  p:last-child {margin:0;}
  .pg__bd {max-width:540px;}
</style>